import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Connects three selects (hour 1-12, minute 00/30, AM/PM) into a hidden
// field that holds the 24-hour "HH:MM" value for Rails.
// Each select is enhanced with Tom Select for type-to-filter.
export default class extends Controller {
  static targets = ["hour", "minute", "period", "hidden"]

  connect() {
    this.instances = []

    const baseOpts = {
      controlInput: null,
      allowEmptyOption: false,
      create: false,
      onItemAdd: () => this.sync()
    }

    // Hour gets a typed filter since it has 12 items
    this.instances.push(new TomSelect(this.hourTarget, {
      ...baseOpts,
      controlInput: undefined // allow typing to filter
    }))

    // Minute & period are tiny lists — still nice to have consistent styling
    this.instances.push(new TomSelect(this.minuteTarget, baseOpts))
    this.instances.push(new TomSelect(this.periodTarget, baseOpts))

    this.sync()
  }

  disconnect() {
    this.instances.forEach(ts => ts.destroy())
    this.instances = []
  }

  sync() {
    let h = parseInt(this.hourTarget.value, 10)
    const m = this.minuteTarget.value
    const period = this.periodTarget.value

    if (period === "AM") {
      if (h === 12) h = 0
    } else {
      if (h !== 12) h += 12
    }

    this.hiddenTarget.value = `${String(h).padStart(2, "0")}:${m}`
  }
}
